import React, { FC } from 'react';
import { formatPersonalCode } from 'common/utils';
import ProfileLinkWithAvatar from './ProfileLinkWithAvatar';
import { getInitials } from 'helpers/common';

interface IMemberLinkWithAvatar {
  id: string | number;
  firstName: string;
  lastName: string;
  path?: string;
  memberStatus?: string;
  imageUrl?: string;
  titleClass?: string;
  onClick?: () => void;
}

const MemberLinkWithAvatar: FC<IMemberLinkWithAvatar> = ({
  id,
  firstName,
  lastName,
  path = '/members',
  memberStatus,
  imageUrl,
  titleClass,
  onClick,
}) => {
  const label = `${formatPersonalCode(Number(id))} - ${firstName} ${lastName}`;
  const initials = getInitials(firstName, lastName);

  return (
    <ProfileLinkWithAvatar
      label={label}
      link={`${path}/${id}`}
      initials={initials}
      titleClass={titleClass}
      memberStatus={memberStatus}
      imageUrl={imageUrl}
      onClick={onClick}
    />
  );
};

export default MemberLinkWithAvatar;
